import type {ActionResponse, Auth} from 'typings/portaro.be.types';
import type {PayloadActionResponse} from 'typings/portaro.fe.types';
import {createPayloadActionResponse} from '../modal-utils';

/**
 * @ngdoc controller
 * @name ModalLoginController
 * @module portaro.conversation
 */
export default class ModalLoginController {
    public static controllerName = 'ModalLoginController';

    private formCancelFunction: () => void;
    private submitFunction: (promise: Promise<PayloadActionResponse<Auth>>) => any;

    public init(formCancelFunction: () => void, submitFunction: (promise: Promise<ActionResponse>) => any) {
        this.formCancelFunction = formCancelFunction;
        this.submitFunction = submitFunction;
    }

    public closeFormOnCancel() {
        this.formCancelFunction();
    }

    public closeFormOnSuccess(currentAuth: Auth) {
        this.submitFunction(Promise.resolve(createPayloadActionResponse(currentAuth)));
    }
}
